(function () {
  if (window.__toriMobileConceptLoaded) return;
  window.__toriMobileConceptLoaded = true;

  document.documentElement.classList.add('mobile-concept-js');

  function initReveal(root) {
    var sections = root.querySelectorAll('.ts-concept-section');
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        section.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.24 });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function initHeroShine(root) {
    var shineEnterDuration = 1700;
    var shineStartDelay = 520;
    var shineAnimationDuration = 6800;
    var shineExitDuration = 1700;
    var shineInitialDelay = 240;
    var shinePhaseClasses = [
      'is-shine-entering',
      'is-shine-running',
      'is-shine-exiting',
      'is-shine-active'
    ];

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    root.querySelectorAll('.ts-concept-hero__title').forEach(function (title) {
      var shines = Array.prototype.slice.call(title.querySelectorAll('.ts-concept-hero__shine'));
      if (!shines.length) return;
      var shineTimers = [];
      var initialTimer = null;

      if (title.dataset.tsHeroShineReady === 'true') {
        return;
      }

      title.dataset.tsHeroShineReady = 'true';
      shines.forEach(function (shine) {
        shine.dataset.tsHeroShineReady = 'true';
      });

      function clearTimers() {
        shineTimers.forEach(function (timer) {
          window.clearTimeout(timer);
        });
        shineTimers = [];
      }

      function clearInitialTimer() {
        if (!initialTimer) return;
        window.clearTimeout(initialTimer);
        initialTimer = null;
      }

      function clearShine() {
        clearTimers();
        shines.forEach(function (shine) {
          shine.classList.remove.apply(shine.classList, shinePhaseClasses);
        });
      }

      function playShine() {
        if (prefersReducedMotion()) {
          clearShine();
          return;
        }

        clearInitialTimer();
        clearShine();
        void title.offsetWidth;
        shines.forEach(function (shine) {
          shine.classList.add('is-shine-entering');
        });

        shineTimers.push(window.setTimeout(function () {
          shines.forEach(function (shine) {
            shine.classList.remove('is-shine-entering');
            shine.classList.add('is-shine-running');
          });
        }, shineStartDelay));

        shineTimers.push(window.setTimeout(function () {
          shines.forEach(function (shine) {
            shine.classList.remove('is-shine-running');
            shine.classList.add('is-shine-exiting');
          });
        }, shineStartDelay + shineAnimationDuration));

        shineTimers.push(window.setTimeout(function () {
          shines.forEach(function (shine) {
            shine.classList.remove('is-shine-exiting');
          });
          shineTimers = [];
        }, shineStartDelay + shineAnimationDuration + shineExitDuration));
      }

      function queueInitialShine(delay) {
        if (title.dataset.tsHeroInitialShinePlayed === 'true') return;

        title.dataset.tsHeroInitialShinePlayed = 'true';
        if (initialTimer) {
          window.clearTimeout(initialTimer);
        }

        initialTimer = window.setTimeout(function () {
          initialTimer = null;
          playShine();
        }, typeof delay === 'number' ? delay : shineInitialDelay);
      }

      function observeInitialShine() {
        if (!('IntersectionObserver' in window)) {
          queueInitialShine(shineInitialDelay);
          return;
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            observer.unobserve(entry.target);
            queueInitialShine(shineInitialDelay);
          });
        }, { threshold: 0.55 });

        observer.observe(title);
      }

      if (window.PointerEvent) {
        title.addEventListener('pointerenter', playShine);
      } else {
        title.addEventListener('mouseenter', playShine);
      }
      title.addEventListener('click', playShine);
      title.addEventListener('focusin', playShine);
      shines.forEach(function (shine) {
        shine.addEventListener('click', playShine);
        shine.addEventListener('tori:hero-shine:trigger', function () {
          queueInitialShine(shineInitialDelay);
        });
        shine.addEventListener('tori:hero-shine:reset', function () {
          clearInitialTimer();
          clearShine();
        });
      });

      observeInitialShine();
    });
  }

  function initDimensions(root) {
    root.querySelectorAll('[data-ts-dimensions]').forEach(function (section) {
      if (section.dataset.tsDimensionsReady === 'true') return;
      section.dataset.tsDimensionsReady = 'true';

      var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-ts-dimension-button]'));
      var details = Array.prototype.slice.call(section.querySelectorAll('[data-ts-dimension-detail]'));

      function setActive(id) {
        buttons.forEach(function (button) {
          var active = button.getAttribute('data-dimension-id') === id;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-expanded', active ? 'true' : 'false');
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        details.forEach(function (detail) {
          var active = detail.getAttribute('data-dimension-id') === id;
          detail.classList.toggle('is-active', active);
          detail.toggleAttribute('hidden', !active);
        });
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var id = button.getAttribute('data-dimension-id');
          var isActive = button.classList.contains('is-active');
          setActive(isActive ? '' : id);
        });
      });

      if (buttons.length) {
        setActive(buttons[0].getAttribute('data-dimension-id'));
      }
    });
  }

  function initCoreDecks(root) {
    root.querySelectorAll('[data-ts-core-deck]').forEach(function (deck) {
      if (deck.dataset.tsCoreDeckReady === 'true') return;
      deck.dataset.tsCoreDeckReady = 'true';

      var cards = Array.prototype.slice.call(deck.querySelectorAll('[data-ts-core-card]'));
      if (!cards.length) return;

      var previewStep = 20;
      var swipeThreshold = 72;
      var motionTimer = null;
      var settleTimer = null;
      var activePointerId = null;
      var startX = 0;
      var startY = 0;
      var dragX = 0;
      var dragY = 0;
      var dragging = false;
      var verticalGesture = false;
      var suppressClick = false;
      var activeIndex = cards.findIndex(function (card) {
        return card.classList.contains('is-active');
      });
      if (activeIndex < 0) activeIndex = 0;

      function prefersReducedMotion() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      function wrappedPosition(cardIndex, index) {
        var position = cardIndex - index;
        if (position < 0) position += cards.length;
        return position;
      }

      function clearMotionClasses() {
        if (motionTimer) {
          window.clearTimeout(motionTimer);
          motionTimer = null;
        }
        if (settleTimer) {
          window.clearTimeout(settleTimer);
          settleTimer = null;
        }
        deck.classList.remove('is-dragging', 'is-settling');
        cards.forEach(function (card) {
          card.classList.remove('is-dragging', 'is-snapping-back', 'is-swiping-away', 'is-restacking');
          card.style.setProperty('--drag-y', '0px');
        });
      }

      function applyState(index, options) {
        options = options || {};
        var previewCount = Math.max(cards.length - 1, 0);

        deck.style.setProperty('--preview-count', previewCount);
        deck.setAttribute('data-active-index', String(index));

        cards.forEach(function (card, cardIndex) {
          var position = wrappedPosition(cardIndex, index);
          var active = position === 0;
          var nextPreview = position === 1;
          var trigger = card.querySelector('[data-ts-core-card-trigger]');
          var content = card.querySelector('[data-ts-core-card-content]');
          var stackY = active ? 0 : position * previewStep;
          var stackZ = active ? cards.length + 2 : cards.length + 1 - position;

          card.classList.toggle('is-active', active);
          card.classList.toggle('is-preview', !active);
          card.classList.toggle('is-next-preview', nextPreview);

          card.style.setProperty('--stack-y', stackY + 'px');
          card.style.setProperty('--stack-z', String(stackZ));
          card.style.setProperty('--stack-depth', String(active ? 0 : position));
          card.classList.toggle('is-restacking', Boolean(options.markRestacking && !active));

          if (trigger) {
            trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
            trigger.setAttribute('tabindex', active ? '0' : '-1');
            trigger.setAttribute('aria-hidden', active ? 'false' : 'true');
          }

          if (content) {
            content.toggleAttribute('hidden', !active && !nextPreview);
          }
        });
      }

      function setActive(index, animate) {
        var shouldAnimate = animate && !prefersReducedMotion() && index !== activeIndex;

        if (!shouldAnimate) {
          clearMotionClasses();
          applyState(index);
          activeIndex = index;
          return;
        }

        clearMotionClasses();
        deck.classList.add('is-settling');
        applyState(index, { markRestacking: true });
        activeIndex = index;

        settleTimer = window.setTimeout(function () {
          settleTimer = null;
          clearMotionClasses();
        }, 520);
      }

      function boundedDrag(value) {
        var limit = Math.max(132, Math.min(220, deck.offsetHeight * 0.48));
        return Math.max(-limit, Math.min(limit, value));
      }

      function setDrag(value) {
        var activeCard = cards[activeIndex];
        if (!activeCard) return;
        dragY = boundedDrag(value);
        activeCard.style.setProperty('--drag-y', dragY + 'px');
      }

      function nextIndex() {
        return (activeIndex + 1) % cards.length;
      }

      function settleAfterShuffle(index) {
        motionTimer = null;
        cards.forEach(function (card) {
          card.classList.remove('is-swiping-away', 'is-dragging');
          card.style.setProperty('--drag-y', '0px');
        });
        deck.classList.remove('is-dragging');
        deck.classList.add('is-settling');
        applyState(index, { markRestacking: true });
        activeIndex = index;

        settleTimer = window.setTimeout(function () {
          settleTimer = null;
          clearMotionClasses();
        }, 520);
      }

      function shuffle(direction) {
        if (cards.length < 2) {
          setActive(activeIndex, false);
          return;
        }

        var outgoing = cards[activeIndex];
        var index = nextIndex();

        if (prefersReducedMotion()) {
          setActive(index, false);
          return;
        }

        if (motionTimer) {
          window.clearTimeout(motionTimer);
          motionTimer = null;
        }
        if (settleTimer) {
          window.clearTimeout(settleTimer);
          settleTimer = null;
        }
        cards.forEach(function (card) {
          if (card !== outgoing) card.classList.remove('is-dragging', 'is-snapping-back', 'is-swiping-away', 'is-restacking');
        });
        deck.classList.remove('is-settling');
        deck.classList.add('is-dragging');
        outgoing.classList.remove('is-dragging', 'is-snapping-back');
        outgoing.classList.add('is-swiping-away');
        outgoing.style.setProperty('--stack-z', String(cards.length + 3));
        outgoing.style.setProperty('--drag-y', (direction * (deck.offsetHeight + 120)) + 'px');

        motionTimer = window.setTimeout(function () {
          settleAfterShuffle(index);
        }, 260);
      }

      function snapBack() {
        var activeCard = cards[activeIndex];
        if (!activeCard) return;
        activeCard.classList.add('is-snapping-back');
        activeCard.style.setProperty('--drag-y', '0px');

        settleTimer = window.setTimeout(function () {
          settleTimer = null;
          clearMotionClasses();
        }, 280);
      }

      function startDrag(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (cards.length < 2) return;

        var activeCard = cards[activeIndex];
        if (!activeCard) return;
        if (event.target.closest('[data-ts-core-card]') !== activeCard) return;

        clearMotionClasses();
        activePointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        dragX = 0;
        dragY = 0;
        dragging = true;
        verticalGesture = false;
        suppressClick = false;
        deck.classList.add('is-dragging');
        activeCard.classList.add('is-dragging');
        activeCard.setPointerCapture(event.pointerId);
      }

      function moveDrag(event) {
        if (!dragging || event.pointerId !== activePointerId) return;

        dragX = event.clientX - startX;
        var nextDragY = event.clientY - startY;

        if (!verticalGesture) {
          if (Math.abs(nextDragY) < 8 && Math.abs(dragX) < 8) return;
          if (Math.abs(nextDragY) < Math.abs(dragX)) return;
          verticalGesture = true;
        }

        event.preventDefault();
        suppressClick = true;
        setDrag(nextDragY);
      }

      function finishDrag(event) {
        if (!dragging || event.pointerId !== activePointerId) return;

        var activeCard = cards[activeIndex];
        dragging = false;
        activePointerId = null;
        if (activeCard && activeCard.hasPointerCapture(event.pointerId)) {
          activeCard.releasePointerCapture(event.pointerId);
        }
        if (Math.abs(dragY) >= swipeThreshold) {
          shuffle(dragY < 0 ? -1 : 1);
          return;
        }
        snapBack();
      }

      deck.addEventListener('pointerdown', startDrag);
      deck.addEventListener('pointermove', moveDrag);
      deck.addEventListener('pointerup', finishDrag);
      deck.addEventListener('pointercancel', finishDrag);

      cards.forEach(function (card, index) {
        var trigger = card.querySelector('[data-ts-core-card-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', function (event) {
          if (suppressClick) {
            event.preventDefault();
            suppressClick = false;
            return;
          }
          if (index === activeIndex) shuffle(1);
        });

        trigger.addEventListener('keydown', function (event) {
          if (index !== activeIndex) return;
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            shuffle(event.key === 'ArrowUp' ? -1 : 1);
          }
        });
      });

      deck.addEventListener('shopify:block:select', function (event) {
        var card = event.target.closest('[data-ts-core-card]');
        var index = cards.indexOf(card);
        if (index >= 0) setActive(index, true);
      });

      setActive(activeIndex >= 0 ? activeIndex : 0, false);
    });
  }

  function initSliders(root) {
    root.querySelectorAll('[data-ts-slider]').forEach(function (slider) {
      if (slider.closest('[data-ts-possibility-experience]')) return;
      if (slider.dataset.tsSliderReady === 'true') return;
      slider.dataset.tsSliderReady = 'true';

      var knob = slider.querySelector('[data-ts-slider-knob]');
      var target = slider.getAttribute('data-target-url') || '#';
      if (!knob) return;

      var startX = 0;
      var currentX = 0;
      var maxX = 0;
      var dragging = false;

      function setX(value) {
        currentX = Math.max(0, Math.min(maxX, value));
        slider.style.setProperty('--slider-x', currentX + 'px');
      }

      function measure() {
        maxX = Math.max(0, slider.clientWidth - knob.offsetWidth - 10);
      }

      knob.addEventListener('pointerdown', function (event) {
        measure();
        dragging = true;
        startX = event.clientX - currentX;
        slider.classList.add('is-dragging');
        knob.setPointerCapture(event.pointerId);
      });

      knob.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        setX(event.clientX - startX);
      });

      function finish() {
        if (!dragging) return;
        dragging = false;
        slider.classList.remove('is-dragging');
        if (maxX > 0 && currentX > maxX * 0.78 && target) {
          window.location.href = target;
          return;
        }
        setX(0);
      }

      knob.addEventListener('pointerup', finish);
      knob.addEventListener('pointercancel', finish);
      knob.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          window.location.href = target;
        }
      });
      window.addEventListener('resize', function () {
        measure();
        setX(Math.min(currentX, maxX));
      });
    });
  }

  function initDelayedVideos(root) {
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-ts-delayed-video]'));
    if (!videos.length) return;

    function playVideo(video) {
      video.dataset.tsDelayedVideoPlayed = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = false;

      try {
        video.currentTime = 0;
      } catch (error) {
        // Some streamed sources do not allow seeking before metadata loads.
      }

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    function setupVideoLoop(video) {
      if (video.dataset.tsDelayedVideoLoopReady === 'true') return;
      video.dataset.tsDelayedVideoLoopReady = 'true';
      video.loop = false;

      video.addEventListener('ended', function () {
        var loopDelay = parseInt(video.getAttribute('data-ts-video-loop-delay'), 10);
        window.setTimeout(function () {
          playVideo(video);
        }, isNaN(loopDelay) ? 12000 : loopDelay);
      });
    }

    function scheduleVideo(video) {
      if (video.dataset.tsDelayedVideoReady === 'true') return;
      video.dataset.tsDelayedVideoReady = 'true';
      var delay = parseInt(video.getAttribute('data-ts-video-delay'), 10);
      window.setTimeout(function () {
        playVideo(video);
      }, isNaN(delay) ? 4000 : delay);
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(setupVideoLoop);
      videos.forEach(scheduleVideo);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        scheduleVideo(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.24 });

    videos.forEach(function (video) {
      setupVideoLoop(video);
      observer.observe(video);
    });
  }

  function initCtaTextAnimation(root) {
    var ctaTextElements = Array.prototype.slice.call(root.querySelectorAll('.ts-concept-solutions__cta span'));
    if (!ctaTextElements.length) return;

    function startAnimation(element) {
      element.classList.add('is-start-animation-ready');
    }

    if (!('IntersectionObserver' in window)) {
      ctaTextElements.forEach(startAnimation);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        startAnimation(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.6 });

    ctaTextElements.forEach(function (element) {
      if (element.dataset.tsStartAnimationReady === 'true') return;
      element.dataset.tsStartAnimationReady = 'true';
      observer.observe(element);
    });
  }

  function initContactModal(root) {
    var modal = document.querySelector('[data-ts-contact-modal]');
    if (!modal || modal.dataset.tsContactModalReady === 'true') return;
    modal.dataset.tsContactModalReady = 'true';

    var panel = modal.querySelector('[data-ts-contact-modal-panel]');
    var form = modal.querySelector('form');
    var closeButtons = Array.prototype.slice.call(modal.querySelectorAll('[data-ts-contact-modal-close]'));
    var errorEl = modal.querySelector('[data-ts-contact-modal-error]');
    var successEl = modal.querySelector('[data-ts-contact-modal-success]');
    var serverSuccessEl = modal.querySelector('[data-ts-contact-modal-server-success]');
    var submitButton = modal.querySelector('[data-ts-contact-modal-submit]');
    var submitText = modal.querySelector('[data-ts-contact-modal-submit-text]');
    var defaultSubmitText = submitText ? submitText.textContent : '';
    var initialErrorText = errorEl ? errorEl.textContent.trim() : '';
    var hasServerError = Boolean(initialErrorText);
    var hasServerSuccess = Boolean(serverSuccessEl && !serverSuccessEl.hidden);
    var opener = null;
    var closeTimer = null;
    var transitionTimer = null;
    var scrollY = 0;
    var bodyStyle = {};
    var htmlStyle = {};

    function getFocusableElements() {
      return Array.prototype.slice.call(modal.querySelectorAll('a[href], area[href], input:not([type="hidden"]), select, textarea, button:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
        return !element.hasAttribute('hidden') && element.offsetParent !== null;
      });
    }

    function setLoading(isLoading) {
      if (!submitButton || !submitText) return;
      submitButton.disabled = isLoading;
      submitButton.classList.toggle('is-loading', isLoading);
      submitText.textContent = isLoading ? modal.dataset.tsLoadingText : defaultSubmitText;
      if (form) {
        form.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      }
    }

    function setError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function resetModal(keepServerError) {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (form) {
        form.hidden = false;
        form.reset();
        form.setAttribute('aria-busy', 'false');
      }
      if (successEl) {
        successEl.hidden = true;
      }
      setLoading(false);
      if (keepServerError && hasServerError) {
        setError(initialErrorText);
      } else {
        setError('');
      }
    }

    function lockScroll() {
      scrollY = window.scrollY || window.pageYOffset || 0;
      bodyStyle = {
        overflow: document.body.style.overflow
      };
      htmlStyle = {
        overflow: document.documentElement.style.overflow
      };
      document.body.classList.add('ts-contact-modal-open');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    function unlockScroll() {
      document.body.classList.remove('ts-contact-modal-open');
      document.body.style.overflow = bodyStyle.overflow || '';
      document.documentElement.style.overflow = htmlStyle.overflow || '';
      if ((window.scrollY || window.pageYOffset || 0) !== scrollY) {
        window.scrollTo(0, scrollY);
      }
    }

    function openModal(trigger, options) {
      opener = trigger || document.activeElement;
      resetModal(Boolean(options && options.keepServerError));
      if (transitionTimer) {
        window.clearTimeout(transitionTimer);
        transitionTimer = null;
      }
      modal.hidden = false;
      modal.setAttribute('data-state', 'opening');
      lockScroll();
      window.requestAnimationFrame(function () {
        modal.classList.add('is-open');
        modal.setAttribute('data-state', 'open');
        var focusFirstField = !window.matchMedia || window.matchMedia('(min-width: 680px)').matches;
        var firstField = focusFirstField && form ? form.querySelector('input:not([type="hidden"]), textarea, button') : null;
        if (firstField) {
          firstField.focus({ preventScroll: true });
        } else if (panel) {
          panel.focus({ preventScroll: true });
        }
      });
    }

    function closeModal() {
      if (modal.hidden) return;
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (transitionTimer) {
        window.clearTimeout(transitionTimer);
      }
      modal.classList.remove('is-open');
      modal.setAttribute('data-state', 'closing');
      transitionTimer = window.setTimeout(function () {
        modal.hidden = true;
        modal.removeAttribute('data-state');
        unlockScroll();
        resetModal();
        if (opener && typeof opener.focus === 'function') {
          opener.focus({ preventScroll: true });
        }
      }, 240);
    }

    function showSuccess() {
      setLoading(false);
      setError('');
      if (form) {
        form.hidden = true;
      }
      if (successEl) {
        successEl.hidden = false;
        successEl.focus && successEl.focus({ preventScroll: true });
      }
      closeTimer = window.setTimeout(closeModal, 2000);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ts-contact-modal-trigger]');
      if (!trigger) return;
      event.preventDefault();
      openModal(trigger);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (event) {
      if (event.target.hasAttribute('data-ts-contact-modal-backdrop')) {
        closeModal();
      }
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = getFocusableElements();
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (window.location.hash === '#TsContactModalForm' && (hasServerError || hasServerSuccess)) {
      openModal(null, { keepServerError: hasServerError });
      if (hasServerSuccess) {
        window.setTimeout(showSuccess, 0);
      }
    }
  }

  function initFluidText(root) {
    var elements = Array.prototype.slice.call(root.querySelectorAll('.ts-concept-fluid-text'));
    if (!elements.length) return;
    var cycleDuration = 5600;
    var oneShotDuration = 6500;
    var colorStops = [
      '#FF2D95',
      '#FF4083',
      '#FF5270',
      '#FF655E',
      '#FF784B',
      '#FF8A39',
      '#FF9D26'
    ];
    var activeElements = [];
    var fluidFrame = null;

    function shouldReduceMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function gradientForPhase(phase) {
      var normalized = phase % 1;
      if (normalized < 0) normalized += 1;

      var stops = [];
      for (var cycle = -1; cycle <= 1; cycle += 1) {
        colorStops.forEach(function (color, index) {
          var position = ((cycle + (index / colorStops.length) - normalized) * 100).toFixed(3);
          stops.push(color + ' ' + position + '%');
        });
      }

      return 'linear-gradient(110deg, ' + stops.join(', ') + ')';
    }

    function applyColors(element) {
      var phase = parseFloat(element.dataset.tsFluidPhase || '0');
      element.style.setProperty('--ts-fluid-gradient', gradientForPhase(phase));
    }

    function tickFluid(now) {
      activeElements = activeElements.filter(function (element) {
        return element.classList.contains('is-fluid-active') || element.classList.contains('is-fluid-held');
      });

      activeElements.forEach(function (element) {
        var lastTick = parseFloat(element.dataset.tsFluidLastTick || String(now));
        var phase = parseFloat(element.dataset.tsFluidPhase || '0');
        var elapsed = Math.max(0, now - lastTick);
        phase = (phase + (elapsed / cycleDuration)) % 1;
        element.dataset.tsFluidPhase = String(phase);
        element.dataset.tsFluidLastTick = String(now);
        applyColors(element);
      });

      if (activeElements.length) {
        fluidFrame = window.requestAnimationFrame(tickFluid);
      } else {
        fluidFrame = null;
      }
    }

    function startColorCycle(element) {
      element.dataset.tsFluidLastTick = String(window.performance.now());
      applyColors(element);
      if (activeElements.indexOf(element) < 0) {
        activeElements.push(element);
      }
      if (!fluidFrame) {
        fluidFrame = window.requestAnimationFrame(tickFluid);
      }
    }

    function stopColorCycle(element) {
      delete element.dataset.tsFluidLastTick;
    }

    function setOrigin(element, event) {
      if (!event || typeof event.clientX !== 'number' || typeof event.clientY !== 'number') {
        element.style.setProperty('--ts-fluid-origin-x', '50%');
        element.style.setProperty('--ts-fluid-origin-y', '50%');
        return;
      }

      var rect = element.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      element.style.setProperty('--ts-fluid-origin-x', clamp(x, 0, 100) + '%');
      element.style.setProperty('--ts-fluid-origin-y', clamp(y, 0, 100) + '%');
    }

    function play(element, event) {
      if (shouldReduceMotion()) return;
      if (element.dataset.tsFluidTimer) {
        window.clearTimeout(parseInt(element.dataset.tsFluidTimer, 10));
        delete element.dataset.tsFluidTimer;
      }
      if (element.dataset.tsFluidActiveTimer) {
        window.clearTimeout(parseInt(element.dataset.tsFluidActiveTimer, 10));
        delete element.dataset.tsFluidActiveTimer;
      }
      setOrigin(element, event);
      element.classList.remove('is-fluid-held');
      element.classList.remove('is-fluid-active');
      element.offsetHeight;
      element.classList.add('is-fluid-active');
      startColorCycle(element);
      element.dataset.tsFluidActiveTimer = String(window.setTimeout(function () {
        delete element.dataset.tsFluidActiveTimer;
        element.classList.remove('is-fluid-active');
        stopColorCycle(element);
      }, oneShotDuration));
    }

    function hold(element, event) {
      if (shouldReduceMotion()) return;
      if (element.dataset.tsFluidTimer) {
        window.clearTimeout(parseInt(element.dataset.tsFluidTimer, 10));
        delete element.dataset.tsFluidTimer;
      }
      if (element.dataset.tsFluidActiveTimer) {
        window.clearTimeout(parseInt(element.dataset.tsFluidActiveTimer, 10));
        delete element.dataset.tsFluidActiveTimer;
      }
      setOrigin(element, event);
      element.classList.remove('is-fluid-active');
      element.classList.add('is-fluid-held');
      startColorCycle(element);
    }

    function release(element) {
      element.classList.remove('is-fluid-held');
      stopColorCycle(element);
    }

    function schedule(element, delay) {
      if (shouldReduceMotion()) return;
      if (element.dataset.tsFluidTimer) {
        window.clearTimeout(parseInt(element.dataset.tsFluidTimer, 10));
      }
      element.dataset.tsFluidTimer = String(window.setTimeout(function () {
        delete element.dataset.tsFluidTimer;
        play(element);
      }, delay));
    }

    function prepare(element) {
      if (element.dataset.tsFluidReady === 'true') return;
      element.dataset.tsFluidReady = 'true';
      if (!element.getAttribute('data-text')) {
        element.setAttribute('data-text', element.textContent.trim());
      }

      element.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'mouse') return;
        hold(element, event);
      });
      element.addEventListener('pointerleave', function () {
        release(element);
      });
      element.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse') return;
        element.dataset.tsFluidPointerActive = 'true';
        hold(element, event);
        if (element.setPointerCapture) {
          element.setPointerCapture(event.pointerId);
        }
      });
      element.addEventListener('pointerup', function (event) {
        if (event.pointerType === 'mouse') return;
        release(element);
      });
      element.addEventListener('pointercancel', function (event) {
        if (event.pointerType === 'mouse') return;
        release(element);
      });
      element.addEventListener('lostpointercapture', function () {
        release(element);
      });
      element.addEventListener('click', function (event) {
        if (element.classList.contains('is-fluid-held')) return;
        if (element.dataset.tsFluidPointerActive === 'true') {
          delete element.dataset.tsFluidPointerActive;
          return;
        }
        play(element, event);
      });
      element.addEventListener('focusin', function () {
        hold(element);
      });
      element.addEventListener('focusout', function () {
        release(element);
      });
    }

    elements.forEach(prepare);

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        schedule(element, 300);
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        schedule(entry.target, 300);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.6 });

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function readPossibilityData(section) {
    var script = section.querySelector('[data-ts-possibility-data]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function escapeHtml(value) {
    var decoded = document.createElement('textarea');
    decoded.innerHTML = String(value || '');

    return decoded.value.replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  var POSSIBILITY_DIAGNOSTIC = {
    schemaVersion: 2,
    strengthOrder: [
      'working_brand_value',
      'working_marketing_reach',
      'working_marketing_attribution',
      'working_website_next_step',
      'working_offer_value',
      'working_customer_communication',
      'working_growth_capacity'
    ],
    frictionOrder: [
      'friction_brand_overlooked',
      'friction_visibility_effort',
      'friction_marketing_attribution',
      'friction_website_next_step',
      'friction_offer_value',
      'friction_customer_followup',
      'friction_growth_capacity'
    ],
    profiles: {
      demand_brand: { performanceArea: 'Demand', connectedService: 'Brand' },
      demand_marketing: { performanceArea: 'Demand', connectedService: 'Marketing' },
      demand_technology: { performanceArea: 'Demand', connectedService: 'Technology' },
      inquiry_technology: { performanceArea: 'Inquiry', connectedService: 'Technology' },
      conversion_brand: { performanceArea: 'Conversion', connectedService: 'Brand' },
      inquiry_operations: { performanceArea: 'Inquiry', connectedService: 'Operations' },
      fulfillment_operations: { performanceArea: 'Fulfillment', connectedService: 'Operations' }
    },
    assetLedger: {
      working_brand_value: { paths: { demand_brand: 4, conversion_brand: 2 } },
      working_marketing_reach: { paths: { demand_marketing: 4, demand_operations: 2 } },
      working_marketing_attribution: { paths: { demand_technology: 4, demand_marketing: 2, conversion_marketing: 1 } },
      working_website_next_step: { paths: { inquiry_technology: 4, inquiry_brand: 2, conversion_technology: 2 } },
      working_offer_value: { paths: { conversion_brand: 4, inquiry_brand: 2, conversion_marketing: 1 } },
      working_customer_communication: { paths: { inquiry_operations: 4, conversion_operations: 3, fulfillment_marketing: 2 } },
      working_growth_capacity: { paths: { fulfillment_operations: 4, fulfillment_technology: 3, fulfillment_brand: 1 } }
    },
    liabilityLedger: {
      friction_brand_overlooked: {
        primaryProfileId: 'demand_brand',
        paths: { demand_brand: -4, conversion_brand: -3, inquiry_brand: -1 }
      },
      friction_visibility_effort: {
        primaryProfileId: 'demand_marketing',
        paths: { demand_marketing: -4, demand_operations: -3 }
      },
      friction_marketing_attribution: {
        primaryProfileId: 'demand_technology',
        paths: { demand_technology: -4, demand_marketing: -2, conversion_marketing: -1 }
      },
      friction_website_next_step: {
        primaryProfileId: 'inquiry_technology',
        paths: { inquiry_technology: -4, inquiry_marketing: -3, conversion_technology: -2 }
      },
      friction_offer_value: {
        primaryProfileId: 'conversion_brand',
        paths: { conversion_brand: -4, conversion_marketing: -3, inquiry_brand: -2 }
      },
      friction_customer_followup: {
        primaryProfileId: 'inquiry_operations',
        paths: { inquiry_operations: -4, conversion_operations: -3, fulfillment_marketing: -2, fulfillment_technology: -1 }
      },
      friction_growth_capacity: {
        primaryProfileId: 'fulfillment_operations',
        paths: { fulfillment_operations: -4, fulfillment_technology: -3, fulfillment_brand: -2 }
      }
    }
  };

  function isSafariBrowser() {
    var userAgent = window.navigator.userAgent;
    var isSafari = /safari/i.test(userAgent);
    var isChromium = /chrome|chromium|crios|edg|opr|fxios/i.test(userAgent);
    return isSafari && !isChromium && !/android/i.test(userAgent);
  }

  function initPossibilityExperiences(root) {
    root.querySelectorAll('[data-ts-possibility-experience]').forEach(function (section) {
      if (section.dataset.tsPossibilityReady === 'true') return;
      section.dataset.tsPossibilityReady = 'true';

      var useSafariFallback = isSafariBrowser();
      if (useSafariFallback && section.querySelector('[data-ts-safari-video-fallback]')) {
        section.classList.add('is-safari-video-fallback');
        section.querySelectorAll('[data-ts-delayed-video]').forEach(function (video) {
          video.removeAttribute('data-ts-delayed-video');
          video.pause();
        });
      }

      var data = readPossibilityData(section);
      var screen = section.querySelector('[data-ts-possibility-screen]');
      var panel = section.querySelector('[data-ts-possibility-panel]');
      var slider = section.querySelector('[data-ts-slider]');
      var knob = section.querySelector('[data-ts-slider-knob]');

      if (!data || !screen || !slider || !knob) return;

      var selections = {};
      var priorityFrictionId = null;
      var step = 0;
      var unlocked = false;
      var startX = 0;
      var currentX = 0;
      var maxX = 0;
      var dragging = false;

      function resetSelections() {
        data.screens.forEach(function (item) {
          selections[item.id] = [];
        });
        priorityFrictionId = null;
      }

      resetSelections();

      function measure() {
        maxX = Math.max(0, slider.clientWidth - knob.offsetWidth - 10);
      }

      function setSliderProgress(value) {
        currentX = Math.max(0, Math.min(maxX, value));
        section.style.setProperty('--slider-progress', maxX ? (currentX / maxX).toFixed(3) : '0');
        slider.style.setProperty('--slider-x', currentX + 'px');
      }

      function unlock() {
        if (unlocked) return;
        unlocked = true;
        measure();
        setSliderProgress(maxX);
        if (panel) {
          panel.removeAttribute('inert');
          panel.setAttribute('aria-hidden', 'false');
        }
        section.classList.add('is-unlocked');
        renderQuestion(0);
        window.setTimeout(function () {
          var firstOption = screen.querySelector('.ts-concept-possibility__option');
          if (firstOption) firstOption.focus({ preventScroll: true });
        }, 420);
      }

      function resetExperience() {
        unlocked = false;
        dragging = false;
        step = 0;
        resetSelections();
        slider.classList.remove('is-dragging');
        section.classList.remove('is-unlocked', 'is-result');
        screen.classList.remove('is-entering');
        screen.innerHTML = '';
        if (panel) {
          panel.setAttribute('inert', '');
          panel.setAttribute('aria-hidden', 'true');
        }
        measure();
        setSliderProgress(0);
        window.setTimeout(function () {
          knob.focus({ preventScroll: true });
        }, 120);
      }

      function getScreen(screenId) {
        return data.screens.find(function (item) {
          return item.id === screenId;
        });
      }

      function getOption(screenId, optionId) {
        var source = getScreen(screenId);
        if (!source) return null;
        return source.options.find(function (option) {
          return option.id === optionId;
        }) || null;
      }

      function optionOrder(screenId) {
        if (screenId === 'working') return POSSIBILITY_DIAGNOSTIC.strengthOrder;
        if (screenId === 'friction') return POSSIBILITY_DIAGNOSTIC.frictionOrder;
        var source = getScreen(screenId);
        return source ? source.options.map(function (option) { return option.id; }) : [];
      }

      function orderIndex(screenId, id) {
        var order = optionOrder(screenId);
        var index = order.indexOf(id);
        return index >= 0 ? index : 999;
      }

      function sortIds(screenId, ids) {
        var order = optionOrder(screenId);
        return ids.filter(function (id, index) {
          return ids.indexOf(id) === index && order.indexOf(id) >= 0;
        }).sort(function (a, b) {
          return order.indexOf(a) - order.indexOf(b);
        });
      }

      function pathParts(path) {
        var parts = String(path || '').split('_');
        return {
          performanceArea: parts[0] || '',
          connectedService: parts.slice(1).join('_')
        };
      }

      function sharesPerformance(paths, performanceArea) {
        var expected = String(performanceArea || '').toLowerCase();
        return Object.keys(paths || {}).some(function (path) {
          return pathParts(path).performanceArea === expected;
        });
      }

      function sharesService(paths, connectedService) {
        var expected = String(connectedService || '').toLowerCase();
        return Object.keys(paths || {}).some(function (path) {
          return pathParts(path).connectedService === expected;
        });
      }

      function strongestWeight(paths) {
        return Object.keys(paths || {}).reduce(function (strongest, path) {
          return Math.max(strongest, Math.abs(paths[path] || 0));
        }, 0);
      }

      function directWeight(paths, profileId) {
        return Math.abs((paths || {})[profileId] || 0);
      }

      function validatePriority() {
        var selectedFrictionIds = sortIds('friction', selections.friction || []);
        if (selectedFrictionIds.indexOf(priorityFrictionId) < 0) {
          priorityFrictionId = selectedFrictionIds.length === 1 ? selectedFrictionIds[0] : null;
        }
      }

      function resultFallback() {
        return {
          visible: {
            headline: '',
            copy: data.fallback
          },
          resultObject: {
            schemaVersion: POSSIBILITY_DIAGNOSTIC.schemaVersion,
            primaryProfileId: null,
            primaryFrictionId: null,
            selectedFrictionIds: [],
            supportingFrictionIds: [],
            selectedStrengthIds: [],
            displayedStrengthIds: [],
            priorityIds: [],
            performanceArea: '',
            connectedService: '',
            mixedSignal: false,
            mixedSignalStrengthId: null
          }
        };
      }

      function rankStrengthIds(ids, primaryProfileId, profileMeta) {
        return ids.slice().sort(function (a, b) {
          var aPaths = (POSSIBILITY_DIAGNOSTIC.assetLedger[a] || {}).paths || {};
          var bPaths = (POSSIBILITY_DIAGNOSTIC.assetLedger[b] || {}).paths || {};
          var comparisons = [
            directWeight(bPaths, primaryProfileId) - directWeight(aPaths, primaryProfileId),
            Number(sharesPerformance(bPaths, profileMeta.performanceArea)) - Number(sharesPerformance(aPaths, profileMeta.performanceArea)),
            Number(sharesService(bPaths, profileMeta.connectedService)) - Number(sharesService(aPaths, profileMeta.connectedService)),
            strongestWeight(bPaths) - strongestWeight(aPaths),
            orderIndex('working', a) - orderIndex('working', b)
          ];
          return comparisons.find(function (value) { return value !== 0; }) || 0;
        });
      }

      function displayedStrengthIds(selectedStrengthIds, primaryProfileId, profileMeta) {
        var ranked = rankStrengthIds(selectedStrengthIds, primaryProfileId, profileMeta);
        if (selectedStrengthIds.length <= 2) return sortIds('working', selectedStrengthIds);
        if (!ranked.length) return [];
        var first = ranked[0];
        var firstPaths = (POSSIBILITY_DIAGNOSTIC.assetLedger[first] || {}).paths || {};
        var remaining = ranked.filter(function (id) {
          return id !== first;
        });
        var alternate = remaining.filter(function (id) {
          var paths = (POSSIBILITY_DIAGNOSTIC.assetLedger[id] || {}).paths || {};
          return sharesPerformance(paths, profileMeta.performanceArea) !== sharesPerformance(firstPaths, profileMeta.performanceArea) || sharesService(paths, profileMeta.connectedService) !== sharesService(firstPaths, profileMeta.connectedService);
        });
        var secondPool = alternate.length ? alternate : remaining;
        return sortIds('working', [first].concat(secondPool.slice(0, 1)));
      }

      function supportingFrictionIds(selectedFrictionIds, primaryFrictionId, profileMeta, primaryProfileId) {
        return selectedFrictionIds.filter(function (id) {
          return id !== primaryFrictionId;
        }).sort(function (a, b) {
          var aPaths = (POSSIBILITY_DIAGNOSTIC.liabilityLedger[a] || {}).paths || {};
          var bPaths = (POSSIBILITY_DIAGNOSTIC.liabilityLedger[b] || {}).paths || {};
          var comparisons = [
            Number(sharesPerformance(bPaths, profileMeta.performanceArea)) - Number(sharesPerformance(aPaths, profileMeta.performanceArea)),
            Number(sharesService(bPaths, profileMeta.connectedService)) - Number(sharesService(aPaths, profileMeta.connectedService)),
            directWeight(bPaths, primaryProfileId) - directWeight(aPaths, primaryProfileId),
            orderIndex('friction', a) - orderIndex('friction', b)
          ];
          return comparisons.find(function (value) { return value !== 0; }) || 0;
        }).slice(0, 2);
      }

      function buildResult() {
        validatePriority();
        var selectedStrengthIds = sortIds('working', selections.working || []);
        var selectedFrictionIds = sortIds('friction', selections.friction || []);
        var priorityIds = sortIds('priorities', (selections.priorities || []).slice(0, 2));
        var primaryFrictionId = priorityFrictionId;
        var primaryFriction = POSSIBILITY_DIAGNOSTIC.liabilityLedger[primaryFrictionId];
        if (!primaryFriction || selectedFrictionIds.indexOf(primaryFrictionId) < 0) return resultFallback();

        var primaryProfileId = primaryFriction.primaryProfileId;
        var profileMeta = POSSIBILITY_DIAGNOSTIC.profiles[primaryProfileId];
        var profileCopy = data.profiles && data.profiles[primaryProfileId];
        if (!profileMeta || !profileCopy) return resultFallback();

        var rankedMixedStrengths = rankStrengthIds(selectedStrengthIds.filter(function (id) {
          var paths = (POSSIBILITY_DIAGNOSTIC.assetLedger[id] || {}).paths || {};
          return Boolean(paths[primaryProfileId] && primaryFriction.paths[primaryProfileId]);
        }), primaryProfileId, profileMeta);
        var mixedSignalStrengthId = rankedMixedStrengths[0] || null;
        var mixedSignal = Boolean(mixedSignalStrengthId);
        var visibleStrengthIds = displayedStrengthIds(selectedStrengthIds, primaryProfileId, profileMeta);
        if (mixedSignal && visibleStrengthIds.indexOf(mixedSignalStrengthId) < 0) {
          visibleStrengthIds = sortIds('working', [mixedSignalStrengthId].concat(visibleStrengthIds)).slice(0, 2);
        }

        var visibleSupportingFrictionIds = supportingFrictionIds(selectedFrictionIds, primaryFrictionId, profileMeta, primaryProfileId);

        return {
          visible: {
            headline: profileCopy.headline,
            copy: profileCopy.copy
          },
          resultObject: {
            schemaVersion: POSSIBILITY_DIAGNOSTIC.schemaVersion,
            primaryProfileId: primaryProfileId,
            primaryFrictionId: primaryFrictionId,
            selectedFrictionIds: selectedFrictionIds,
            supportingFrictionIds: visibleSupportingFrictionIds,
            selectedStrengthIds: selectedStrengthIds,
            displayedStrengthIds: visibleStrengthIds,
            priorityIds: priorityIds,
            performanceArea: profileMeta.performanceArea,
            connectedService: profileMeta.connectedService,
            mixedSignal: mixedSignal,
            mixedSignalStrengthId: mixedSignalStrengthId
          }
        };
      }

      function refreshOptionStates(item) {
        var selected = selections[item.id] || [];
        var maxSelections = item.id === 'priorities' ? 2 : 0;
        var next = screen.querySelector('[data-ts-possibility-next]');
        screen.querySelectorAll('[data-option-id]').forEach(function (button) {
          var optionId = button.getAttribute('data-option-id');
          var isSelected = selected.indexOf(optionId) >= 0;
          var shouldDisable = Boolean(maxSelections && selected.length >= maxSelections && !isSelected);
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-checked', isSelected ? 'true' : 'false');
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          button.disabled = shouldDisable;
        });
        if (next) next.disabled = selected.length === 0;
      }

      function renderQuestion(index) {
        step = index;
        section.classList.remove('is-result');
        var item = data.screens[step];
        var selected = selections[item.id] || [];
        var instruction = item.id === 'priorities' ? data.priorityInstruction : data.instruction;
        var optionsHtml = item.options.map(function (option) {
          var isSelected = selected.indexOf(option.id) >= 0;
          var isDisabled = item.id === 'priorities' && selected.length >= 2 && !isSelected;
          return '<button class="ts-concept-possibility__option' + (isSelected ? ' is-selected' : '') + '" type="button" role="checkbox" data-option-id="' + escapeHtml(option.id) + '" aria-checked="' + (isSelected ? 'true' : 'false') + '" aria-pressed="' + (isSelected ? 'true' : 'false') + '"' + (isDisabled ? ' disabled' : '') + '>' + escapeHtml(option.label) + '</button>';
        }).join('');

        screen.classList.remove('is-entering');
        void screen.offsetHeight;
        screen.innerHTML = '<div class="ts-concept-possibility__header"><p class="ts-concept-possibility__utility">' + (step + 1) + ' ' + escapeHtml(data.utility) + ' ' + data.screens.length + '</p><h3 class="ts-concept-possibility__question">' + escapeHtml(item.heading) + '</h3><p class="ts-concept-possibility__instruction">' + escapeHtml(instruction) + '</p></div><div class="ts-concept-possibility__options">' + optionsHtml + '</div><div class="ts-concept-possibility__controls"><button class="ts-concept-possibility__control" type="button" data-ts-possibility-back>' + escapeHtml(data.back) + '</button><button class="ts-concept-possibility__control ts-concept-possibility__control--primary" type="button" data-ts-possibility-next' + (selected.length ? '' : ' disabled') + '>' + escapeHtml(step === data.screens.length - 1 ? data.seePossible : data.continue) + '</button></div>';
        screen.classList.add('is-entering');

        screen.querySelectorAll('[data-option-id]').forEach(function (button) {
          button.addEventListener('click', function () {
            var optionId = button.getAttribute('data-option-id');
            var selectedIds = selections[item.id] || [];
            var position = selectedIds.indexOf(optionId);
            if (position >= 0) selectedIds.splice(position, 1);
            else if (item.id !== 'priorities' || selectedIds.length < 2) selectedIds.push(optionId);
            selections[item.id] = sortIds(item.id, selectedIds);
            if (item.id === 'friction') validatePriority();
            refreshOptionStates(item);
          });
        });

        var back = screen.querySelector('[data-ts-possibility-back]');
        var next = screen.querySelector('[data-ts-possibility-next]');
        if (back) {
          back.addEventListener('click', function () {
            if (step === 2 && sortIds('friction', selections.friction || []).length > 1) renderFrictionPriority();
            else if (step > 0) renderQuestion(step - 1);
            else resetExperience();
          });
        }
        if (next) {
          next.addEventListener('click', function () {
            var selectedIds = selections[item.id] || [];
            if (!selectedIds.length) return;
            if (item.id === 'friction') {
              validatePriority();
              if (sortIds('friction', selections.friction || []).length === 1) {
                priorityFrictionId = sortIds('friction', selections.friction || [])[0];
                renderQuestion(step + 1);
              } else {
                renderFrictionPriority();
              }
            } else if (step < data.screens.length - 1) renderQuestion(step + 1);
            else renderResult();
          });
        }
      }

      function renderFrictionPriority() {
        step = 1;
        section.classList.remove('is-result');
        validatePriority();
        var selectedFrictionIds = sortIds('friction', selections.friction || []);
        if (selectedFrictionIds.length <= 1) {
          priorityFrictionId = selectedFrictionIds[0] || null;
          renderQuestion(2);
          return;
        }

        var headingId = 'ts-possibility-priority-' + section.getAttribute('data-wetheme-section-id');
        var optionsHtml = selectedFrictionIds.map(function (id) {
          var option = getOption('friction', id);
          if (!option) return '';
          var isSelected = priorityFrictionId === id;
          return '<button class="ts-concept-possibility__option' + (isSelected ? ' is-selected' : '') + '" type="button" role="radio" data-priority-friction-id="' + escapeHtml(id) + '" aria-checked="' + (isSelected ? 'true' : 'false') + '">' + escapeHtml(option.label) + '</button>';
        }).join('');

        screen.classList.remove('is-entering');
        void screen.offsetHeight;
        screen.innerHTML = '<div class="ts-concept-possibility__header"><p class="ts-concept-possibility__utility">2 ' + escapeHtml(data.utility) + ' ' + data.screens.length + '</p><h3 class="ts-concept-possibility__question" id="' + escapeHtml(headingId) + '">' + escapeHtml(data.priorityQuestion) + '</h3></div><div class="ts-concept-possibility__options" role="radiogroup" aria-labelledby="' + escapeHtml(headingId) + '">' + optionsHtml + '</div><div class="ts-concept-possibility__controls"><button class="ts-concept-possibility__control" type="button" data-ts-possibility-back>' + escapeHtml(data.back) + '</button><button class="ts-concept-possibility__control ts-concept-possibility__control--primary" type="button" data-ts-possibility-next' + (priorityFrictionId ? '' : ' disabled') + '>' + escapeHtml(data.continue) + '</button></div>';
        screen.classList.add('is-entering');

        screen.querySelectorAll('[data-priority-friction-id]').forEach(function (button) {
          button.addEventListener('click', function () {
            priorityFrictionId = button.getAttribute('data-priority-friction-id');
            validatePriority();
            screen.querySelectorAll('[data-priority-friction-id]').forEach(function (optionButton) {
              var isSelected = optionButton.getAttribute('data-priority-friction-id') === priorityFrictionId;
              optionButton.classList.toggle('is-selected', isSelected);
              optionButton.setAttribute('aria-checked', isSelected ? 'true' : 'false');
            });
            var next = screen.querySelector('[data-ts-possibility-next]');
            if (next) next.disabled = !priorityFrictionId;
          });
        });

        var back = screen.querySelector('[data-ts-possibility-back]');
        var next = screen.querySelector('[data-ts-possibility-next]');
        if (back) back.addEventListener('click', function () { renderQuestion(1); });
        if (next) next.addEventListener('click', function () {
          validatePriority();
          if (priorityFrictionId) renderQuestion(2);
        });
        screen.focus({ preventScroll: true });
      }

      function renderResult() {
        var result = buildResult();
        var visible = result.visible;
        section.classList.add('is-result');
        screen.classList.remove('is-entering');
        void screen.offsetHeight;
        screen.innerHTML = '<div class="ts-concept-possibility__result"><div class="ts-concept-possibility__result-card"><h3>' + escapeHtml(data.resultTitle) + '</h3><h4>' + escapeHtml(visible.headline || '') + '</h4><span>' + escapeHtml(data.happeningLabel) + '</span><p>' + escapeHtml(visible.copy || data.fallback) + '</p></div><div class="ts-concept-possibility__controls ts-concept-possibility__controls--single"><button class="ts-concept-possibility__control" type="button" data-ts-possibility-back>' + escapeHtml(data.back) + '</button></div></div>';
        screen.classList.add('is-entering');
        var back = screen.querySelector('[data-ts-possibility-back]');
        if (back) {
          back.addEventListener('click', resetExperience);
        }
        screen.focus({ preventScroll: true });
      }

      knob.addEventListener('pointerdown', function (event) {
        if (unlocked) return;
        measure();
        dragging = true;
        startX = event.clientX - currentX;
        slider.classList.add('is-dragging');
        knob.setPointerCapture(event.pointerId);
      });

      knob.addEventListener('pointermove', function (event) {
        if (!dragging || unlocked) return;
        setSliderProgress(event.clientX - startX);
      });

      function finish() {
        if (!dragging || unlocked) return;
        dragging = false;
        slider.classList.remove('is-dragging');
        if (maxX > 0 && currentX >= maxX - 1) {
          unlock();
          return;
        }
        setSliderProgress(0);
      }

      knob.addEventListener('pointerup', finish);
      knob.addEventListener('pointercancel', finish);
      knob.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          unlock();
        }
      });

      window.addEventListener('resize', function () {
        measure();
        setSliderProgress(unlocked ? maxX : Math.min(currentX, maxX));
      });

      renderQuestion(0);
      if (panel) {
        panel.setAttribute('inert', '');
        panel.setAttribute('aria-hidden', 'true');
      }
      setSliderProgress(0);
    });
  }

  function initWorkCarousels(root) {
    root.querySelectorAll('[data-ts-work-carousel]').forEach(function (carousel) {
      if (carousel.dataset.tsWorkCarouselReady === 'true') {
        carousel.dispatchEvent(new CustomEvent('tori:work-carousel:refresh'));
        return;
      }
      carousel.dataset.tsWorkCarouselReady = 'true';

      var items = Array.prototype.slice.call(carousel.querySelectorAll('[data-ts-work-item]'));
      var dragLayer = carousel.querySelector('[data-ts-work-drag]');
      var active = 0;
      var dragOffset = 0;
      var startX = 0;
      var dragging = false;
      var didDrag = false;

      function wrappedPosition(index) {
        var position = index - active;
        if (position > 2) position -= items.length;
        if (position < -2) position += items.length;
        return position;
      }

      function render() {
        var radius = parseFloat(window.getComputedStyle(carousel).getPropertyValue('--ts-work-carousel-radius')) || 210;
        items.forEach(function (item, index) {
          var p = wrappedPosition(index) + dragOffset / 120;
          var angle = p * (Math.PI * 2 / Math.max(items.length, 5));
          var x = Math.sin(angle) * radius;
          var z = Math.cos(angle);
          var scale = 0.4 + 0.6 * ((z + 1) / 2);
          item.style.setProperty('--x', x.toFixed(2) + 'px');
          item.style.setProperty('--scale', scale.toFixed(3));
          item.style.setProperty('--z', String(Math.round(z * 10) + 10));
          item.style.setProperty('--meta-opacity', z > 0.85 ? '1' : '0');
          item.setAttribute('aria-current', index === active ? 'true' : 'false');
        });
      }

      function rotate(direction) {
        active = (active + direction + items.length) % items.length;
        render();
      }

      items.forEach(function (item, index) {
        item.addEventListener('click', function (event) {
          if (didDrag) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }

          if (item.tagName !== 'A' && index !== active) {
            event.preventDefault();
            active = index;
            render();
            return;
          }

          active = index;
          render();
        });
      });

      if (dragLayer) {
        dragLayer.setAttribute('aria-hidden', 'true');
      }

      carousel.addEventListener('pointerdown', function (event) {
        if (event.button !== undefined && event.button !== 0) return;
        dragging = true;
        didDrag = false;
        startX = event.clientX;
        dragOffset = 0;
        if (carousel.setPointerCapture) {
          carousel.setPointerCapture(event.pointerId);
        }
      });

      carousel.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        dragOffset = Math.max(-140, Math.min(140, event.clientX - startX));
        if (Math.abs(dragOffset) > 8) didDrag = true;
        render();
      });

      function finish(event) {
        if (!dragging) return;
        var offset = event.clientX - startX;
        dragging = false;
        dragOffset = 0;
        if (carousel.releasePointerCapture && carousel.hasPointerCapture(event.pointerId)) {
          carousel.releasePointerCapture(event.pointerId);
        }

        if (offset < -40) rotate(1);
        else if (offset > 40) rotate(-1);
        else render();

        window.setTimeout(function () {
          didDrag = false;
        }, 0);
      }

      carousel.addEventListener('pointerup', finish);
      carousel.addEventListener('pointercancel', finish);
      carousel.addEventListener('tori:work-carousel:refresh', render);

      render();
    });
  }

  function init(root) {
    root = root || document;
    initContactModal(document);
    initReveal(root);
    initHeroShine(root);
    initDimensions(root);
    initCoreDecks(root);
    initPossibilityExperiences(root);
    initSliders(root);
    initDelayedVideos(root);
    initCtaTextAnimation(root);
    initFluidText(root);
    initWorkCarousels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('tori:desktop-presentation:activate', function (event) {
    init(event.detail && event.detail.root ? event.detail.root : document);
  });
})();
